export const FUNDING_STEP_ACTION = 'page/FUNDING_STEP_ACTION';

export const ACTIVATE_CONFIRM_STEP = 'page/ACTIVATE_CONFIRM_STEP';

export const CONFIRM_FUNDING = 'action/CONFIRM_FUNDING';
